import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import Logo from '../../Atoms/Logo';
import Tooltip from '../../Atoms/Tooltip';
import './header.css';

/*
#tailwind
header--preview header--greenroom header--live header--backstage
header__content header__content--left header__content--right header__content--center
*/

function Header({ leftContent, centerContent, rightContent, context, onLogoClick, className, ...other }) {
  return (
    <header className={bem`header--${{ [context]: true }} ${className}`} {...other}>
      <div className={bem`header__content--${{ left: true }}`}>
        <Logo width="16px" height="100%" onClick={onLogoClick} />
        <Tooltip content={<div className="header__tooltipContent">{leftContent}</div>}>
          <div className="header__content__cell">{leftContent}</div>
        </Tooltip>
      </div>
      <span className={bem`header__content--${{ center: true }}`}>{centerContent}</span>
      <div className={bem`header__content--${{ right: true }}`}>
        <Tooltip content={<div className="header__tooltipContent">{rightContent}</div>}>
          <div className="header__content__cell">{rightContent}</div>
        </Tooltip>
      </div>
    </header>
  );
}

Header.propTypes = {
  leftContent: PropTypes.node,
  centerContent: PropTypes.node,
  rightContent: PropTypes.node,
  context: PropTypes.oneOf(['preview', 'greenroom', 'live', 'backstage']),
  icon: PropTypes.node,
  onLogoClick: PropTypes.func,
  className: PropTypes.string,
};

Header.defaultProps = {
  leftContent: undefined,
  centerContent: undefined,
  rightContent: undefined,
  context: 'preview',
  icon: undefined,
  onLogoClick: undefined,
  className: undefined,
};

export default Header;
